<template>
  <div class="h-full relative">
    <div class="store-menus">
      <b-loading :active="isGettingMenu" />
      <a
        href="#"
        class="font-medium hover:text-primary-500 text-gray-500 text-sm"
        @click.prevent="backToMainPage"
      >
        <i class="fill-current icon-chevron-left-bold" />

        {{ isGroupBuyings ? '返回一起訂東西': '返回店家資訊頁' }}
      </a>
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-between mb-5 mt-4 min-w-1/2 max-w-21.25">
          <w-input
            ref="menuName"
            :disabled="isGroupBuyings"
            :maxLength="40"
            :message="menuNameErrorMsg"
            :show-error="v$.menuName.$invalid"
            class="flex-grow"
            v-model.lazy="menuName"
          >
            <template #label>
              <label class="text-gray-500">
                菜單名稱
              </label>
              <span class="mr-4 text-red-500">*</span>
            </template>
          </w-input>
          <w-button
            v-if="inEdit && !isGroupBuyings"
            :disabled="isLoading"
            :loading="isDeletingMenu"
            class="flex-grow-0 flex-shrink-0 ml-5"
            colorType="secondary"
            type="link"
            @click="showOnDeleteMenuDialog = true"
          >
            <i class="icon-trash mr-2" />
            <span>刪除菜單</span>
          </w-button>
        </div>
        <div class="flex items-center">
          <w-button
            v-if="!inEdit"
            rounded
            size="sm"
            type="link"
            @click="showAddMultiple = true"
          >
            <i class="icon-upload mr-2" />
            <span>批次匯入品項</span>
          </w-button>
          <add-multiple-menu-items
            v-model="showAddMultiple"
            @add="replaceItems"
            @close="showAddMultiple = false"
          />
        </div>
      </div>
      <menu-items-editor
        :categories="categories"
        :error-categories-messages="errorCategoriesMessages"
        :in-edit="inEdit"
        :show-add-category-btn="showAddCategoryBtn"
        :menu="menu"
      />
      <menu-common-dialog
        cancel-text="不儲存並離開"
        confirm-text="繼續編輯"
        title="修改尚未儲存"
        v-model="showOnLeaveDialog"
        @cancel="backToMainPage"
        @close="onContinueEdit"
        @confirm="onContinueEdit"
      >
        <template #content>
          <p>請注意，菜單尚有未儲存的修改，確定離開？</p>
        </template>
      </menu-common-dialog>
      <menu-common-dialog
        :loading="isDeletingMenu"
        title="刪除菜單"
        v-model="showOnDeleteMenuDialog"
        @cancel="onCloseDeleteMenuDialog"
        @close="onCloseDeleteMenuDialog"
        @confirm="onDeleteMenu()"
      >
        <template #content>
          <div class="flex flex-col">
            <p>確定刪除此菜單嗎？刪除菜單將不會影響目前已有的訂購。</p>
            <p>請注意，刪除後將無法還原菜單。</p>
          </div>
        </template>
      </menu-common-dialog>
    </div>
    <div class="store-menus__actions">
      <span v-if="v$.$invalid" class="mr-2 text-red-500">
        {{ errorText }}
      </span>
      <w-button
        :disabled="isLoading || (v$.$dirty && v$.$invalid)"
        :loading="isLoading"
        @click="inEdit ? onSave() : onCreate()"
      >
        儲存菜單
      </w-button>
    </div>
  </div>
</template>

<script>
import StoreMenus from './StoreMenus';

export default StoreMenus;
</script>

<style lang="scss" scoped>
@import 'StoreMenus';
</style>
